/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type StorefrontFeaturedSection_seller$ref = any;
export type StorefrontFeaturedSection_seller = {
    readonly sellerPreferences: {
        readonly urlLabel: string | null;
    } | null;
    readonly " $refType": StorefrontFeaturedSection_seller$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "StorefrontFeaturedSection_seller",
    "type": "Seller",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "sellerPreferences",
            "storageKey": null,
            "args": null,
            "concreteType": "SellerPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "urlLabel",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'bc08d8a399155d5520d7651d9b726063';
export default node;
